import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as S from './Input.styled';
import { DropDownArrowUp, DropDownArrowDown, Search, ClearSearchInput, Close } from 'assets/icons';
import { Loader, SwitchUserItem } from 'components';
import { useFacade } from './useFacade';
import { selectPb_email, selectPb_username } from 'store/selectors';
import { globalAPI } from 'services/global.service';
import { useDebounce } from 'utils';
import uuid from 'react-uuid';

const Input = ({ toggling, isOpen, isLoading }) => {
  const currentPb_email = useSelector(selectPb_email);
  const currentPb_username = useSelector(selectPb_username);

  const [trigger, result] = globalAPI.useLazyGetPublisherListQuery();

  const {
    searchInputFocus,
    setSearchInputFocus,
    faundedUsers,
    searchValue,
    setSearchValue,
    handleClearSearchValue,
    handleClick,
    getPublisherLink,
  } = useFacade(result?.data);
  const debouncedValue = useDebounce(searchValue, 450);

  useEffect(() => {
    if (searchValue.length > 3 && debouncedValue.length > 3) {
      trigger(searchValue);
    }
  }, [debouncedValue]);

  return (
    <S.DropDownContainer className='dropdown_base'>
      <S.DropDownHeader onClick={toggling} isOpen={isOpen}>
        <span>
          {currentPb_username} ({currentPb_email})
        </span>
        {isOpen ? <DropDownArrowDown /> : <DropDownArrowUp />}
      </S.DropDownHeader>

      <S.DropDownListContainer isOpen={isOpen}>
        {isLoading && <Loader.Global />}
        <S.HeaderWrap>
          <S.Header>Switch user</S.Header>
          <div onClick={toggling}>
            <Close />
          </div>
        </S.HeaderWrap>
        <S.SearchInputWrapper>
          <S.SearchInput
            id={uuid()}
            onFocus={() => setSearchInputFocus(true)}
            onBlur={() => setSearchInputFocus(false)}
            placeholder='Search App'
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <S.SearchIconWrapper isFocusable={searchInputFocus}>
            <Search />
          </S.SearchIconWrapper>
          <S.ClearSearchInputWrapper visible={!!searchValue} onClick={handleClearSearchValue}>
            <ClearSearchInput />
          </S.ClearSearchInputWrapper>
        </S.SearchInputWrapper>
        <S.ListWrap>
          <S.DropDownList>
            {result.data && faundedUsers.length === 0 && <span>No result. Try again.</span>}
            {faundedUsers?.map((user) => (
              <SwitchUserItem
                {...user}
                key={user.pb_number}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(user);
                  const url = getPublisherLink(user.pb_number);
                  window.open(url, '_blank');
                }}
                onContextMenu={(e) => {
                  e.preventDefault();
                  const url = getPublisherLink(user.pb_number);
                  window.location.href = url;
                }}
                userType={user.userType}
                searchValue={searchValue}
                getLink={getPublisherLink}
              />
            ))}
          </S.DropDownList>
        </S.ListWrap>
      </S.DropDownListContainer>
    </S.DropDownContainer>
  );
};

export default Input;
